import * as React from 'react';
import { observer, Provider } from 'mobx-react';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observable, makeObservable } from 'mobx';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Route, Switch } from 'react-router';
import { ApplicationPageSummaryPane } from '../../components/organisms/application/ApplicationPageSummaryPane';
import { ApplicationPageUserInfoPane } from '../../components/organisms/application/ApplicationPageUserInfoPane';
import { ApplicationPageUserSignInPane } from '../../components/organisms/application/ApplicationPageUserSignInPane';
import { ApplicationPageUserSummaryPane } from '../../components/organisms/application/ApplicationPageUserSummaryPane';
import { ApplicationPagePaymentInfoPane } from '../../components/organisms/application/ApplicationPagePaymentInfoPane';
import { ApplicationConfirmationPane } from '../../components/organisms/application/ApplicationConfirmationPane';
import { ApplicationPageCompletePaneForMoney } from '../../components/organisms/application/ApplicationPageCompletePane';
import { ApplicationStartDateSelectionPane } from '../../components/organisms/application/ApplicationStartDateSelectionPane';
import { ApplicationPageUserAddressPane } from '../../components/organisms/application/ApplicationPageUserAddressPane';
import { ApplicationPageContext, ApplicationPageHeaderType } from '../../contexts/applicaitonPageContext';
import { MoneyApplicationPageState } from './states/MoneyApplicationPageState';

export const MoneyApplicationPage = withNavigation(NavigationSpecs.money())(
  observer(
    class MoneyApplicationPage extends React.Component {
      pageState = new MoneyApplicationPageState(GlobalStatesV3.currentUser, GlobalStatesV3.routing);

      constructor(props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount() {
        this.pageState.init();
      }

      render() {
        const { routeGroup } = this.pageState;
        return (
          <Provider applicationState={this.pageState}>
            <ApplicationPageContext.Provider value={{ headerType: ApplicationPageHeaderType.TEXT }}>
              <Switch>
                <Route
                  exact
                  path={routeGroup.applicationSignIn().stringify()}
                  component={(props) => (
                    <ApplicationPageUserSignInPane
                      {...props}
                      redirectUrl={() => routeGroup.applicationUserSummary().stringify()}
                    />
                  )}
                />
                <Route
                  exact
                  path={routeGroup.applicationUserInfo().stringify()}
                  component={(props) => (
                    <ApplicationPageUserInfoPane
                      {...props}
                      signInPageUrl={routeGroup.applicationSignIn()}
                      nextButtonLabel={'住所情報の入力へ'}
                    />
                  )}
                />
                <Route
                  exact
                  path={routeGroup.applicationUserSummary().stringify()}
                  component={(props) => (
                    <ApplicationPageUserSummaryPane {...props} nextButtonLabel={'住所情報の入力へ'} />
                  )}
                />
                <Route
                  exact
                  path={routeGroup.applicationAddressInfo().stringify()}
                  component={ApplicationPageUserAddressPane}
                />
                <Route
                  exact
                  path={routeGroup.applicationStartDateSelect().stringify()}
                  component={ApplicationStartDateSelectionPane}
                />
                <Route
                  exact
                  path={routeGroup.applicationSummary().stringify()}
                  component={ApplicationPageSummaryPane}
                />
                <Route
                  exact
                  path={routeGroup.applicationPaymentMethod().stringify()}
                  component={ApplicationPagePaymentInfoPane}
                />
                <Route
                  exact
                  path={routeGroup.applicationConfirmation().stringify()}
                  component={ApplicationConfirmationPane}
                />
                <Route
                  exact
                  path={routeGroup.applicationComplete().stringify()}
                  component={ApplicationPageCompletePaneForMoney}
                />
              </Switch>
            </ApplicationPageContext.Provider>
          </Provider>
        );
      }
    }
  )
);
